const buttons = document.querySelectorAll('.tab-button');
const contents = document.querySelectorAll('.tab-content');
const customerSwipers = [];

document.querySelectorAll('.customer-swiper-wrap').forEach((wrap) => {
  const swiperElement = wrap.querySelector('.customer-swiper');

  if (!swiperElement) return;

  const slideCount = swiperElement.querySelectorAll('.swiper-slide').length;

  const swiper = new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: slideCount > 1,

    navigation: {
      nextEl: wrap.querySelector('.detail-main-next'),
      prevEl: wrap.querySelector('.detail-main-prev'),
    },

    pagination: {
      el: wrap.querySelector('.customer-swiper-pagination'),
      clickable: true,
    },
  });

  customerSwipers.push(swiper);
});


buttons.forEach((button) => {
  button.addEventListener('click', () => {
    const target = button.dataset.tab;
    const targetContent = document.getElementById(target);

    if (!targetContent) return;

    buttons.forEach((btn) => {
      btn.classList.remove('active');
    });

    contents.forEach((content) => {
      content.classList.remove('active');
    });

    button.classList.add('active');
    targetContent.classList.add('active');

    const targetSwiper = targetContent.querySelector('.customer-swiper');

    if (targetSwiper?.swiper) {
      targetSwiper.swiper.update();
      targetSwiper.swiper.updateSize();
      targetSwiper.swiper.updateSlides();
    }
  });
});
